<template>
    <div class="slide-wrapper">
        <div class="background"></div>
        <div class="content-container slide-content">
            <div class="noise">
                <img :src="require('@/assets/noise_' + this.index + '.gif')" alt="">
            </div>
            <div class="title">
                <h2 class="carousel-title">{{ title }}</h2>
                <div class="mobile-helper">Read more</div>
            </div>
            <div class="graphic">
                <div class="image">
                    <div class="box"></div>
                    <img :src="require('@/assets/img_' + this.index + '.png')" alt="" class="character">
                    <div class="blob"></div>
                </div>
            </div>
        </div>
        <div class="cursor-view"></div>
    </div>
</template>

<script>
    import LottieEnter from 'lottie-web'
    import * as animationEnter1 from '@/assets/graphic_in_1.json'
    import * as animationEnter2 from '@/assets/graphic_in_2.json'
    import * as animationEnter3 from '@/assets/graphic_in_3.json'

    export default {
        name: 'Slide',
        data: function() {
            return {
                graphicEnter: null,
                graphicLoop: null
            }
        },
        props: ['title', 'index', 'bus'],
        mounted: function() {
            let animationData = null;

            switch ((this.index - 1) % 3) {
                case 0:
                    animationData = animationEnter1;
                    break;
                case 1:
                    animationData = animationEnter2;
                    break;
                case 2:
                    animationData = animationEnter3;
                    break;
            }

            this.graphicEnter = LottieEnter.loadAnimation({
                container: this.$el.querySelector('.blob'),
                animationData: animationData.default,
                renderer: 'svg',
                autoplay: false,
            });

            this.bus.$on('transition-exit', (slideNum) => {
                if (slideNum == this.index) {
                    this.exit();
                }
            })

            this.bus.$on('transition-enter', (slideNum) => {
                if (slideNum == this.index) {
                    this.enter();
                }
            })

            // this.$el.querySelector('.box').style.backgroundColor = this.index % 2 == 1 ? '#333333' : '#2b2b2b';
            // this.$el.querySelector('.background').style.backgroundColor = this.index % 2 == 0 ? '#333333' : '#2b2b2b';

            this.$el.querySelector('.cursor-view').addEventListener('mouseover', (e) => {
                this.$store.commit('cursorChange', {
                    show: true,
                    event: e
                });
            })

            this.$el.querySelector('.cursor-view').addEventListener('mouseout', (e) => {
                this.$store.commit('cursorChange', {
                    show: false
                })
            })
        },
        methods: {
            enter: function() {
                setTimeout(() => {
                    this.$el.querySelector('.background').classList.add('show');
                    this.$el.querySelector('.carousel-title').classList.add('show');
                    this.$el.querySelector('.graphic').classList.add('show');
                    this.$el.querySelector('.noise').classList.add('show');
                    this.$el.querySelector('.mobile-helper').classList.add('show');
                    this.graphicEnter.setSpeed(1);
                    this.graphicEnter.setDirection(1);
                    this.graphicEnter.play();

                    // this.setSquiggly();
                }, 1000);
            },
            exit: function() {
                this.$el.querySelector('.background').classList.remove('show');
                this.$el.querySelector('.carousel-title').classList.remove('show');
                this.$el.querySelector('.graphic').classList.remove('show');
                this.$el.querySelector('.noise').classList.remove('show');
                this.$el.querySelector('.mobile-helper').classList.remove('show');
                this.graphicEnter.setDirection(-1);
                this.graphicEnter.setSpeed(2);
                this.graphicEnter.play();
            },
            setSquiggly: function() {
                const squiggly = this.$el.querySelector('.squiggly');

                squiggly.style.transform = 'translate3d(' + (Math.random() * 400) + 'px, ' + (Math.random() * 200) + 'px, 0)';
                squiggly.classList.add('show');
            }
        }
    }
</script>

<style lang="scss">
    .slide-wrapper {
        position: relative;
        width: 100%;
        height: 100vh;
        overflow: hidden;

        @media ($mobile-screen) {
            position: fixed;
        }

        .background {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            transform-origin: left;
            transform: scale(0, 1);
            transition: transform 0.65s $primary-ease;
            background-color: #2b2b2b;

            &.show {
                transform-origin: right;
                transform: scale(1, 1);
            }
        }

    }
    .slide-content {
        position: relative;
        height: 100%;
        display: flex;
        align-items: center;

        .noise {
            position: absolute;
            right: 400px;
            z-index: 3;
            opacity: 0;
            transition: opacity 0.65s $primary-ease;
            transform: translate3d(0, 50px, 0);

            @media ($laptop-screen) {
                right: 300px;
            }

            @media ($mobile-screen) {
                display: none;
            }

            &.show {
                opacity: 1
            }
        }

        .title {
            margin-left: 100px;
            color: white;
            opacity: 0;
            transition: opacity 0.65s $primary-ease;
            position: relative;
            z-index: 5;
            height: 200px;

            @media ($tablet-screen) {
                margin-left: 0;
            }

            @media ($mobile-screen) {
                margin-left: 0;
                transform: translate3d(0, 200px, 0);
            }

            .mobile-helper {
                @include mukta-medium;
                display: none;
                font-size: 15px;
                color: $color-red;
                text-transform: uppercase;
                opacity: 0;
                transition: all 0.65s $primary-ease;
                transform: translate3d(0, 10px, 0);

                @media ($mobile-screen) {
                    display: block;

                    &.show {
                        transform: translate3d(0, 0, 0);
                        transition: all 0.65s $primary-ease 0.65s;
                        opacity: 1;
                    }
                }
            }
        }

        .carousel-title {
            font-size: 120px;

            @media ($laptop-screen) {
                font-size: 100px;
            }

            @media ($mobile-screen) {
                font-size: 50px;
            }

            .wrapper {
                display: inline-block;
                overflow: hidden;

                @for $i from 1 through 20 {
                    &:nth-of-type(#{$i}) .letter {
                        transition-delay: $i * 0.005s;
                    }
                }
            }

            .letter {
                transform: translate3d(120px, 0, 0);
                transition: transform 1.25s $primary-ease;

            }

            &.show {
                .letter {
                    transform: translate3d(0, 0, 0);
                }
            }
        }

        .graphic {
            position: absolute;
            top: 0;
            right: 0;
            height: 100%;
            display: flex;
            align-items: center;
            z-index: 4;

            @media ($mobile-screen) {
                opacity: 0.3;
                width: 100%;
            }

            .image {
                position: relative;
                transform: translate3d(-220px, -50px, 0);

                @media ($laptop-screen) {
                    transform: translate3d(-100px, -50px, 0);
                }

                @media ($mobile-screen) {
                    transform: translate3d(-200px, -50px, 0);
                }
            }

            .box {
                width: 390px;
                height: 529px;
                position: absolute;
                bottom: 109px;
                right: 185px;
                transform: rotate(30deg) scale(1, 0);
                transform-origin: center bottom;
                transition: transform 0.65s $primary-ease;
                background-color: #333333;
            }

            .character {
                position: relative;
                z-index: 3;
                opacity: 0;
                transition: opacity 0.65s $primary-ease;
            }

            .blob {
                position: absolute;
                bottom: -33px;
                right: -66px;
                z-index: 4;
                width: 855px;
            }

            &.show {
                .box {
                    transform: rotate(30deg) scale(1, 1);
                }

                .character {
                    opacity: 1;
                }
            }
        }
    }
</style>
